/**
 * Shared email domain suggestion + custom validation behaviour.
 *
 * Attach to any field wrapper with:
 *   <div data-email-suggest>
 *     <input data-email-suggest-input data-msg-required="..." data-msg-invalid="...">
 *     <ul data-email-suggest-list hidden></ul>
 *   </div>
 *
 * Optionally, place an element with [data-email-client-error] inside the
 * <form> (anywhere) to receive custom validation messages instead of the
 * browser's native validation bubble.
 */
(function () {
  'use strict';

  // El script se incluye desde más de una sección; evita registrar los eventos dos veces.
  if (window.__odkEmailSuggestLoaded) return;
  window.__odkEmailSuggestLoaded = true;

  var EMAIL_DOMAINS = [
    'gmail.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'live.com',
    'outlook.es',
    'hotmail.es'
  ];

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getMatches(domainPart) {
    if (!domainPart) return EMAIL_DOMAINS.slice(0, 5);

    return EMAIL_DOMAINS.filter(function (domain) {
      return domain.indexOf(domainPart) === 0 && domain !== domainPart;
    });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function renderSuggestions(wrap, matches, local, typedDomain) {
    var list = wrap.querySelector('[data-email-suggest-list]');
    var input = wrap.querySelector('[data-email-suggest-input]');
    list.innerHTML = '';

    if (!matches.length) {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    matches.forEach(function (domain, index) {
      var item = document.createElement('li');
      item.className = 'email-suggest__option';
      item.setAttribute('role', 'option');
      item.setAttribute('data-email-suggest-item', '');
      item.setAttribute('data-value', local + domain);
      item.innerHTML =
        escapeHtml(local) +
        '<strong>' +
        escapeHtml(typedDomain) +
        '</strong>' +
        escapeHtml(domain.slice(typedDomain.length));
      if (index === 0) item.classList.add('is-active');
      list.appendChild(item);
    });

    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function closeSuggestions(wrap) {
    var list = wrap.querySelector('[data-email-suggest-list]');
    var input = wrap.querySelector('[data-email-suggest-input]');
    list.hidden = true;
    list.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  function applyActiveItem(list, nextItem) {
    var items = list.querySelectorAll('[data-email-suggest-item]');
    items.forEach(function (item) {
      item.classList.toggle('is-active', item === nextItem);
    });
    if (nextItem) nextItem.scrollIntoView({ block: 'nearest' });
  }

  function selectSuggestion(wrap, value) {
    var input = wrap.querySelector('[data-email-suggest-input]');
    input.value = value;
    closeSuggestions(wrap);
    input.focus();
  }

  function initCustomValidation(input) {
    var form = input.closest('form');
    if (!form || form.dataset.emailValidationBound === 'true') return;
    form.dataset.emailValidationBound = 'true';

    var errorEl = form.querySelector('[data-email-client-error]');

    form.noValidate = true;

    function showError(message) {
      if (!errorEl || !message) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', errorEl.id);
    }

    function clearError() {
      if (!errorEl || errorEl.hidden) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
      input.removeAttribute('aria-invalid');
    }

    input.addEventListener('input', clearError);

    form.addEventListener('submit', function (event) {
      var value = input.value.trim();

      if (!value && input.required) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(input.dataset.msgRequired);
        input.focus();
        return;
      }

      if (value && !EMAIL_PATTERN.test(value)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(input.dataset.msgInvalid);
        input.focus();
        return;
      }

      clearError();
    });
  }

  function initField(wrap) {
    if (wrap.dataset.bound === 'true') return;
    wrap.dataset.bound = 'true';

    var input = wrap.querySelector('[data-email-suggest-input]');
    var list = wrap.querySelector('[data-email-suggest-list]');
    if (!input || !list) return;

    input.addEventListener('input', function () {
      var value = input.value;
      var atIndex = value.indexOf('@');

      if (atIndex <= 0) {
        closeSuggestions(wrap);
        return;
      }

      var local = value.slice(0, atIndex + 1);
      var typedDomain = value.slice(atIndex + 1).toLowerCase();

      if (typedDomain.indexOf('@') !== -1) {
        closeSuggestions(wrap);
        return;
      }

      renderSuggestions(wrap, getMatches(typedDomain), local, typedDomain);
    });

    input.addEventListener('keydown', function (event) {
      if (list.hidden) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('[data-email-suggest-item]'));
      if (!items.length) return;

      var activeIndex = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        var nextIndex = activeIndex < items.length - 1 ? activeIndex + 1 : 0;
        applyActiveItem(list, items[nextIndex]);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        var prevIndex = activeIndex > 0 ? activeIndex - 1 : items.length - 1;
        applyActiveItem(list, items[prevIndex]);
      } else if (event.key === 'Enter') {
        if (activeIndex > -1) {
          event.preventDefault();
          selectSuggestion(wrap, items[activeIndex].getAttribute('data-value'));
        }
      } else if (event.key === 'Escape') {
        closeSuggestions(wrap);
      }
    });

    list.addEventListener('mousedown', function (event) {
      var item = event.target.closest('[data-email-suggest-item]');
      if (!item) return;
      event.preventDefault();
      selectSuggestion(wrap, item.getAttribute('data-value'));
    });

    input.addEventListener('blur', function () {
      window.setTimeout(function () {
        closeSuggestions(wrap);
      }, 120);
    });

    initCustomValidation(input);
  }

  function boot() {
    document.querySelectorAll('[data-email-suggest]').forEach(initField);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
